import {useContext} from 'react';
import {ThemeContext} from '../lib/ThemeProvider/';
import HFCLLightTheme from '../token/theme/HFCLLightTheme';

const useTheme = () => {
  const themeContext = useContext(ThemeContext);
  const {theme} = themeContext || HFCLLightTheme;

  return theme;
};


export default useTheme;
